export default "__VITE_ASSET__B76IMoLS__"